import { create } from 'zustand';

export interface LoginNotice {
  previousLoginDateTime: string | null;
  previousLoginIp: string | null;
  failCountBeforeLogin: number;
  loginFailures: { dateTime: string; ip: string }[];
}

interface LoginNoticeStore {
  notice: LoginNotice | null;
  show: (notice: LoginNotice) => void;
  close: () => void;
}

export const useLoginNoticeStore = create<LoginNoticeStore>((set) => ({
  notice: null,
  show: (notice) => set({ notice }),
  close: () => set({ notice: null }),
}));
